import React from 'react';
import { Icon } from './Icon.js';
export const IconHousePen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 22L21.5 16.5L18.5 13.5L13 19V22H16Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12.5996 1.2002L21.5996 7.9502L22 8.25V12.7598L20 10.7598V9.24902L12 3.24902L4 9.24902V20H10V22H2V8.25L2.40039 7.9502L11.4004 1.2002L12 0.75L12.5996 1.2002Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconHousePen.js.map